// extracted by mini-css-extract-plugin
module.exports = {"container":"_2r8uY0","title":"_2vIfGG _3gMFZ8 mz-home-header","cover":"_27yMD4 DQu01J"};